/**
 * z_variant-picker-wccg-cart.js — Cart-funktioner for WCCG Variant Picker
 * ========================================================================
 * Del af: z_variant-picker-wccg snippet-pakken
 *
 * Filer i pakken:
 *   snippets/z_variant-picker-wccg.liquid          ← UI, styling, variant-data
 *   assets/z_variant-picker-wccg-cart.js            ← Cart: add, drawer, redirect (denne fil)
 *   assets/z_variant-picker-wccg-inventory.js       ← Lagerbeholdning + udsolgt badge
 *   assets/z_variant-picker-wccg-related.js         ← Relaterede produkter / upsell 
 *
 * Afhængigheder:
 *   - Kræver window.WCCG (eksponeret af snippet'en)
 *   - W.cartMode styrer adfærd: 'drawer' | 'redirect' | 'auto'
 *
 * Self-contained: Bygger egen cart-drawer hvis temaet ikke har en.
 * Genbruger temaets .drawer CSS-klasser for native look.
 * Ingen afhængighed til theme.js updateCartDrawer() eller Kaching.
 *
 * Changelog:
 *   022 — Drawer konverteret til <dialog> med showModal().
 *         Bruger browserens TOP LAYER — over ALLE z-index inkl. Kaching.
 *         Lukker automatisk andre åbne dialogs. Backdrop via ::backdrop.
 *   020 — CSS <style> suppress tilgang.
 *   018 — App-injicerede cart drawers identificeret via debug.
 *   016 — z-index max, altid egen drawer.
 *   015 — suppressThemeDrawer() FØR fetch. Alert-intercept.
 *
 *   023 — cfg_cart_mode 'checkout': redirect til /checkout efter add
 *         (med gift-app delay som drawer-mode).
 *
 * Version: 1.10 | Build: 023 | Date: 2026-08-06
 */
(function() {
  var W = window.WCCG;
  if (!W || !W.picker) return;

  var MODE = W.cartMode || 'auto';
  var DRAWER_ID = 'WccgCartDrawer';
  var OVERLAY_ID = 'WccgCartOverlay';
  var drawerCartTotal = 0;
  var drawerIsOpen = false;
  var originalUpdateCartDrawer = null;
  var originalAlert = null;
  var BIN_SVG = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>';

  function log(msg, data) {
    if (data !== undefined) console.log('[' + W.name + ':cart] ' + msg, data);
    else console.log('[' + W.name + ':cart] ' + msg);
  }

  log('module loaded \u2014 cartMode: ' + MODE);

  /* ══════════════════════════════════════════════════════════════
     CART ITEMS — byg array af varer til /cart/add.js
     ══════════════════════════════════════════════════════════════ */
  function getCartItems() {
    var items = [];
    W.labels.forEach(function(label, i) {
      var qty = W.getVal(label);
      if (qty > 0) {
        var variantId = W.inputs[i].dataset.variantId;
        var packQty = parseInt(W.inputs[i].dataset.quantity) || 1;
        if (variantId && variantId.length > 0) {
          items.push({ id: parseInt(variantId), quantity: packQty * qty });
        }
        var giftId = W.inputs[i].dataset.giftVariantId;
        var giftQty = parseInt(W.inputs[i].dataset.giftQuantity) || 0;
        if (giftId && giftId.length > 0 && giftId !== '0' && giftQty > 0) {
          items.push({
            id: parseInt(giftId),
            quantity: giftQty * qty,
            properties: { '_gift': 'true', '_free': 'true' }
          });
        }
      }
    });
    return items;
  }

  /* ══════════════════════════════════════════════════════════════
     SELF-CONTAINED DRAWER — oprettes dynamisk i DOM
     Genbruger temaets .drawer CSS-klasser for native udseende.
     ══════════════════════════════════════════════════════════════ */
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return amount + ' kr';
  }

  function ensureDrawer() {
    if (document.getElementById(DRAWER_ID)) return;

    /* Inject drawer styles + backdrop */
    var drawerStyle = document.createElement('style');
    drawerStyle.id = 'wccg-drawer-style';
    drawerStyle.textContent =
      'dialog#' + DRAWER_ID + ' {' +
        'position:fixed;top:0;right:0;bottom:0;left:auto;' +
        'margin:0;padding:0;border:none;' +
        'width:420px;max-width:90vw;max-height:100vh;height:100vh;' +
        'background:#1c1d1d;color:#fff;' +
        'overflow:hidden;box-shadow:-4px 0 20px rgba(0,0,0,0.3);' +
      '}' +
      'dialog#' + DRAWER_ID + '::backdrop {' +
        'background:rgba(0,0,0,0.5);' +
      '}' +
      'dialog#' + DRAWER_ID + ' a, dialog#' + DRAWER_ID + ' button {' +
        'cursor:pointer;' +
      '}';
    document.head.appendChild(drawerStyle);

    var showCartLink = W.showCartLink !== false;

    var drawer = document.createElement('dialog');
    drawer.id = DRAWER_ID;
    drawer.innerHTML =
      '<div style="display:flex;flex-direction:column;height:100%;">' +
        '<div style="padding:16px 25px;border-bottom:1px solid rgba(255,255,255,0.15);display:flex;justify-content:space-between;align-items:center;">' +
          '<div style="font-size:18px;font-weight:600;">Indkøbskurv</div>' +
          '<button type="button" id="WccgCartClose" style="background:none;border:none;color:#fff;cursor:pointer;padding:4px 8px;font-size:13px;display:flex;align-items:center;gap:6px;opacity:0.8;">' +
            '<span style="font-size:11px;">&#9664;</span> Shop videre' +
          '</button>' +
        '</div>' +
        '<div style="flex:1;overflow-y:auto;">' +
          '<div id="WccgCartItems" style="padding:15px 25px;"></div>' +
          '<div id="WccgDrawerRelated" style="display:none;"></div>' +
        '</div>' +
        '<div style="padding:15px 25px;border-top:1px solid rgba(255,255,255,0.15);">' +
          '<div style="display:flex;justify-content:space-between;margin-bottom:12px;font-size:16px;">' +
            '<span>Subtotal</span>' +
            '<span id="WccgCartTotal" style="font-weight:600;"></span>' +
          '</div>' +
          '<div id="WccgCartSavings" style="display:none;text-align:right;font-size:13px;color:#4caf50;margin-bottom:10px;"></div>' +
          (showCartLink ? '<a id="WccgBtnCart" href="/cart" style="display:block;text-align:center;padding:12px;background:transparent;color:#fff;text-decoration:none;border-radius:4px;font-weight:500;font-size:14px;border:1px solid rgba(255,255,255,0.3);margin-bottom:8px;">Se indkøbskurv</a>' : '') +
          '<a id="WccgBtnCheckout" href="/checkout" style="display:block;text-align:center;padding:14px;background:#a26b25;color:#fff;text-decoration:none;border-radius:4px;font-weight:600;font-size:15px;">Gå til kassen</a>' +
        '</div>' +
      '</div>';
    document.body.appendChild(drawer);

    document.getElementById('WccgCartClose').addEventListener('click', function(e) { e.stopPropagation(); closeDrawer(); });

    /* Klik på backdrop lukker draweren */
    drawer.addEventListener('click', function(e) {
      if (e.target === drawer) closeDrawer();
    });

    /* Intercept nav — tilføj evt. relaterede produkter først */
    var btnCart = document.getElementById('WccgBtnCart');
    if (btnCart) btnCart.addEventListener('click', function(e) { handleDrawerNav(e, '/cart'); });
    document.getElementById('WccgBtnCheckout').addEventListener('click', function(e) { handleDrawerNav(e, '/checkout'); });

    /* Event delegation for alle knapper i draweren */
    drawer.addEventListener('click', function(e) {
      /* Relaterede produkt-steppers */
      var relBtn = e.target.closest('[data-wccg-drel-minus],[data-wccg-drel-plus]');
      if (relBtn) {
        e.preventDefault();
        e.stopPropagation();
        var row = relBtn.closest('[data-wccg-drel-row]');
        if (!row) return;
        var valEl = row.querySelector('[data-wccg-drel-val]');
        if (!valEl) return;
        var current = parseInt(valEl.textContent) || 0;
        if (relBtn.hasAttribute('data-wccg-drel-minus')) current = Math.max(0, current - 1);
        else current = current + 1;
        valEl.textContent = current;
        updateDrawerTotal();
        return;
      }

      /* Cart item: +/- antal */
      var cartMinus = e.target.closest('[data-wccg-cart-minus]');
      if (cartMinus) {
        e.preventDefault();
        var qty = parseInt(cartMinus.getAttribute('data-qty')) || 1;
        changeCartItem(cartMinus.getAttribute('data-wccg-cart-minus'), Math.max(0, qty - 1));
        return;
      }
      var cartPlus = e.target.closest('[data-wccg-cart-plus]');
      if (cartPlus) {
        e.preventDefault();
        var qtyP = parseInt(cartPlus.getAttribute('data-qty')) || 0;
        changeCartItem(cartPlus.getAttribute('data-wccg-cart-plus'), qtyP + 1);
        return;
      }

      /* Cart item: slet (bin-ikon) */
      var cartDel = e.target.closest('[data-wccg-cart-del]');
      if (cartDel) {
        e.preventDefault();
        changeCartItem(cartDel.getAttribute('data-wccg-cart-del'), 0);
        return;
      }
    });

    log('Drawer element created (#' + DRAWER_ID + ')');
  }

  /* ── Relaterede produkter i draweren ── */
  function renderDrawerRelated() {
    var container = document.getElementById('WccgDrawerRelated');
    if (!container) return;

    var related = window.WCCG_related;
    if (!related || related.length === 0) { container.style.display = 'none'; return; }

    var inv = window.WCCG_inventory || {};
    var available = [];

    related.forEach(function(prod) {
      var v = inv[String(prod.variantId)];
      if (v) {
        if (!v.inventory_management) { available.push(prod); return; }
        if (v.inventory_policy === 'continue') { available.push(prod); return; }
        if (v.available && v.inventory_quantity > 0) { available.push(prod); return; }
        log('Drawer related: ' + prod.title + ' — sold out, skipping');
        return;
      }
      available.push(prod);
    });

    if (available.length === 0) { container.style.display = 'none'; return; }

    var html = '<div style="padding:15px 25px;border-top:2px solid #d35400;">' +
      '<div style="font-size:14px;font-weight:700;text-transform:uppercase;margin-bottom:12px;color:#d35400;">Du kunne også være interesseret i:</div>';

    available.forEach(function(prod) {
      var btnStyle = 'display:inline-flex;align-items:center;justify-content:center;width:28px;height:28px;border:1px solid rgba(255,255,255,0.3);background:none;color:#fff;font-size:16px;cursor:pointer;border-radius:3px;';
      html +=
        '<div data-wccg-drel-row data-variant-id="' + prod.variantId + '" data-price-raw="' + (prod.priceRaw || 0) + '" style="display:flex;gap:10px;padding:10px 0;border-bottom:1px solid rgba(255,255,255,0.08);align-items:flex-start;">' +
          (prod.image ? '<img src="' + prod.image + '" alt="" style="width:55px;height:55px;object-fit:cover;border-radius:4px;flex-shrink:0;">' : '') +
          '<div style="flex:1;min-width:0;">' +
            '<div style="font-size:13px;font-weight:600;line-height:1.3;text-transform:uppercase;">' + prod.title + '</div>' +
            '<div style="font-size:12px;margin-top:2px;">' + prod.price + '</div>' +
            '<a href="' + prod.url + '" target="_blank" style="display:inline-block;margin-top:4px;padding:2px 10px;background:#d35400;color:#fff;text-decoration:none;border-radius:3px;font-size:11px;font-weight:600;">LÆS MERE</a>' +
          '</div>' +
          '<div style="display:flex;align-items:center;gap:4px;flex-shrink:0;margin-top:4px;">' +
            '<button type="button" data-wccg-drel-minus style="' + btnStyle + '">&minus;</button>' +
            '<span data-wccg-drel-val style="display:inline-block;width:24px;text-align:center;font-size:14px;">0</span>' +
            '<button type="button" data-wccg-drel-plus style="' + btnStyle + '">+</button>' +
          '</div>' +
        '</div>';
    });

    html += '</div>';
    container.innerHTML = html;
    container.style.display = 'block';
    log('Drawer related: ' + available.length + ' product(s) rendered');
  }

  /* ── Hent valgte relaterede produkter fra draweren ── */
  function getDrawerRelatedItems() {
    var items = [];
    var rows = document.querySelectorAll('#' + DRAWER_ID + ' [data-wccg-drel-row]');
    rows.forEach(function(row) {
      var valEl = row.querySelector('[data-wccg-drel-val]');
      var qty = parseInt(valEl ? valEl.textContent : '0') || 0;
      var vid = row.getAttribute('data-variant-id');
      if (qty > 0 && vid) {
        items.push({ id: parseInt(vid), quantity: qty });
      }
    });
    return items;
  }

  /* ── Nav-knap handler: tilføj relaterede til cart, derefter redirect ── */
  function handleDrawerNav(e, targetUrl) {
    var relItems = getDrawerRelatedItems();
    if (relItems.length === 0) return; /* ingen relaterede valgt → normal navigation */

    e.preventDefault();
    log('Adding drawer related items before navigation:', JSON.stringify(relItems));

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: relItems })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      log('Drawer related items added, navigating to ' + targetUrl);
      window.location.href = targetUrl;
    })
    .catch(function(err) {
      console.error('[' + W.name + ':cart] Related add error:', err);
      window.location.href = targetUrl;
    });
  }

  /* ── Opdater cart via /cart/change.js (antal eller slet) ── */
  function changeCartItem(lineKey, newQty) {
    log('Changing item ' + lineKey + ' to qty ' + newQty);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: newQty })
    })
    .then(function(r) { return r.json(); })
    .then(function(cartData) {
      log('Cart updated \u2014 items: ' + cartData.item_count + ', total: ' + cartData.total_price);
      updateCartBubble(cartData.item_count);
      renderDrawerItems(cartData);
    })
    .catch(function(err) {
      console.error('[' + W.name + ':cart] Change error:', err);
    });
  }

  function renderDrawerItems(cartData) {
    var container = document.getElementById('WccgCartItems');
    var totalEl = document.getElementById('WccgCartTotal');
    var savingsEl = document.getElementById('WccgCartSavings');
    if (!container || !totalEl) return;

    if (!cartData.items || cartData.items.length === 0) {
      container.innerHTML = '<p style="text-align:center;opacity:0.7;padding:30px 0;">Kurven er tom</p>';
      totalEl.textContent = formatMoney(0);
      if (savingsEl) savingsEl.style.display = 'none';
      return;
    }

    var stepBtnStyle = 'display:inline-flex;align-items:center;justify-content:center;width:26px;height:26px;border:1px solid rgba(255,255,255,0.3);background:none;color:#fff;font-size:14px;cursor:pointer;border-radius:3px;';
    var totalSavings = 0;
    var html = '';

    cartData.items.forEach(function(item) {
      var img = item.image ? item.image.replace(/(\.\w+)$/, '_100x100$1') : '';
      var isGift = item.properties && (item.properties._gift === 'true' || item.properties._free === 'true');
      var lineKey = item.key;

      /* Pris-label */
      var priceHtml = '';
      if (isGift) {
        priceHtml = '<span style="text-decoration:line-through;opacity:0.5;">' + formatMoney(item.original_line_price) + '</span> GRATIS';
        totalSavings += item.original_line_price;
      } else {
        priceHtml = formatMoney(item.line_price);
      }

      /* Rabat-info (under titel, hvis original_line_price > line_price) */
      var discountHtml = '';
      if (!isGift && item.original_line_price > item.line_price) {
        var saved = item.original_line_price - item.line_price;
        totalSavings += saved;
        var discountTitle = '';
        if (item.discounts && item.discounts.length > 0) {
          discountTitle = item.discounts[0].title || '';
        }
        discountHtml = '<div style="font-size:11px;color:#4caf50;margin-top:2px;">' +
          (discountTitle ? discountTitle + ' ' : '') + '(-' + formatMoney(saved) + ')' +
          '</div>';
        priceHtml = '<div style="text-decoration:line-through;opacity:0.5;font-size:12px;">' + formatMoney(item.original_line_price) + '</div>' +
          '<div>' + formatMoney(item.line_price) + '</div>';
      }

      html +=
        '<div style="display:flex;gap:10px;padding:12px 0;border-bottom:1px solid rgba(255,255,255,0.08);align-items:flex-start;">' +
          (img ? '<img src="' + img + '" alt="" style="width:55px;height:55px;object-fit:cover;border-radius:4px;flex-shrink:0;">' : '') +
          '<div style="flex:1;min-width:0;">' +
            '<div style="font-size:14px;font-weight:500;line-height:1.3;">' + item.product_title + '</div>' +
            (item.variant_title && item.variant_title !== 'Default Title' ? '<div style="font-size:12px;opacity:0.6;">' + item.variant_title + '</div>' : '') +
            discountHtml +
            /* Antal-vælger + slet */
            (isGift ? '<div style="font-size:12px;opacity:0.6;margin-top:4px;">Antal: ' + item.quantity + '</div>'
            : '<div style="display:flex;align-items:center;gap:6px;margin-top:6px;">' +
                '<button type="button" data-wccg-cart-minus="' + lineKey + '" data-qty="' + item.quantity + '" style="' + stepBtnStyle + '">&minus;</button>' +
                '<span style="display:inline-block;width:22px;text-align:center;font-size:14px;">' + item.quantity + '</span>' +
                '<button type="button" data-wccg-cart-plus="' + lineKey + '" data-qty="' + item.quantity + '" style="' + stepBtnStyle + '">+</button>' +
                '<button type="button" data-wccg-cart-del="' + lineKey + '" style="background:none;border:none;color:rgba(255,255,255,0.4);cursor:pointer;padding:2px 6px;margin-left:auto;display:flex;align-items:center;" title="Fjern">' + BIN_SVG + '</button>' +
              '</div>') +
          '</div>' +
          '<div style="text-align:right;font-size:14px;font-weight:500;white-space:nowrap;">' + priceHtml + '</div>' +
        '</div>';
    });
    container.innerHTML = html;
    drawerCartTotal = cartData.total_price;
    totalEl.textContent = formatMoney(drawerCartTotal);

    /* Samlet besparelse */
    if (savingsEl) {
      if (totalSavings > 0) {
        savingsEl.textContent = 'Du sparer ' + formatMoney(totalSavings);
        savingsEl.style.display = 'block';
      } else {
        savingsEl.style.display = 'none';
      }
    }

    renderDrawerRelated();
  }

  /* ── Opdater subtotal inkl. valgte relaterede produkter ── */
  function updateDrawerTotal() {
    var totalEl = document.getElementById('WccgCartTotal');
    if (!totalEl) return;

    var relatedExtra = 0;
    var rows = document.querySelectorAll('#' + DRAWER_ID + ' [data-wccg-drel-row]');
    rows.forEach(function(row) {
      var valEl = row.querySelector('[data-wccg-drel-val]');
      var qty = parseInt(valEl ? valEl.textContent : '0') || 0;
      var price = parseInt(row.getAttribute('data-price-raw')) || 0;
      if (qty > 0) relatedExtra += price * qty;
    });

    var newTotal = drawerCartTotal + relatedExtra;
    totalEl.textContent = formatMoney(newTotal);
    if (relatedExtra > 0) {
      log('Subtotal updated: cart ' + formatMoney(drawerCartTotal) + ' + related ' + formatMoney(relatedExtra) + ' = ' + formatMoney(newTotal));
    }
  }

  var SUPPRESS_STYLE_ID = 'wccg-suppress';

  function injectSuppressCSS() {
    if (document.getElementById(SUPPRESS_STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = SUPPRESS_STYLE_ID;
    style.textContent =
      /* Skjul alle tredjeparts cart drawers */
      '#CartDrawer, #CartDrawer *,' +
      'cart-drawer:not(#' + DRAWER_ID + '),' +
      'cart-drawer:not(#' + DRAWER_ID + ') *,' +
      '[class*="cart-drawer"]:not(#' + DRAWER_ID + '):not(#' + OVERLAY_ID + '),' +
      '[class*="cart-drawer"]:not(#' + DRAWER_ID + '):not(#' + OVERLAY_ID + ') *,' +
      'cart-items-component, scroll-hint.cart-drawer__content,' +
      /* Kaching/app overlays og backdrops */
      '[class*="drawer-overlay"]:not(#' + OVERLAY_ID + '),' +
      '[class*="cart-overlay"]:not(#' + OVERLAY_ID + '),' +
      '[class*="drawer__overlay"]:not(#' + OVERLAY_ID + '),' +
      '[class*="kaching"],' +
      '.drawer-backdrop, .cart-backdrop {' +
        'display: none !important;' +
        'visibility: hidden !important;' +
        'opacity: 0 !important;' +
        'pointer-events: none !important;' +
        'width: 0 !important;' +
        'height: 0 !important;' +
        'overflow: hidden !important;' +
      '}' +
      /* Sørg for vores drawer altid er interaktiv */
      '#' + DRAWER_ID + ', #' + DRAWER_ID + ' * {' +
        'pointer-events: auto !important;' +
      '}' +
      '#' + OVERLAY_ID + ' {' +
        'pointer-events: auto !important;' +
      '}' +
      'html.js-drawer-open, html.js-drawer-open-cart {' +
        'overflow: auto !important;' +
      '}';
    document.head.appendChild(style);
    log('Suppress CSS injected');
  }

  function removeSuppressCSS() {
    var style = document.getElementById(SUPPRESS_STYLE_ID);
    if (style) style.remove();
    log('Suppress CSS removed');
  }

  function suppressThemeDrawer() {
    if (typeof window.updateCartDrawer === 'function' && !originalUpdateCartDrawer) {
      originalUpdateCartDrawer = window.updateCartDrawer;
      window.updateCartDrawer = function() {
        log('Theme updateCartDrawer() suppressed');
      };
    }
    if (!originalAlert) {
      originalAlert = window.alert;
      window.alert = function(msg) {
        log('Blocked alert: ' + msg);
      };
    }
    injectSuppressCSS();
    log('Theme/app drawers suppressed');
  }

  function restoreThemeDrawer() {
    if (originalUpdateCartDrawer) {
      window.updateCartDrawer = originalUpdateCartDrawer;
      originalUpdateCartDrawer = null;
    }
    if (originalAlert) {
      window.alert = originalAlert;
      originalAlert = null;
    }
    removeSuppressCSS();
    log('Theme/app drawers restored');
  }

  function openDrawer() {
    var drawer = document.getElementById(DRAWER_ID);
    if (!drawer) return false;

    /* Luk alle andre modale dialogs først */
    document.querySelectorAll('dialog[open]').forEach(function(d) {
      if (d.id !== DRAWER_ID) {
        try { d.close(); } catch(e) {}
        log('Closed foreign dialog: ' + (d.id || d.className || d.tagName));
      }
    });

    drawerIsOpen = true;
    if (!drawer.open) drawer.showModal();

    log('Drawer opened (dialog.showModal)');
    return true;
  }

  function closeDrawer() {
    var drawer = document.getElementById(DRAWER_ID);
    if (drawer && drawer.open) drawer.close();
    drawerIsOpen = false;
    restoreThemeDrawer();
    log('Drawer closed');
  }

  /* ══════════════════════════════════════════════════════════════
     CART BUBBLE — opdater antal-indikator i header
     ══════════════════════════════════════════════════════════════ */
  function updateCartBubble(itemCount) {
    var bubble = document.querySelector('.cart-link__bubble');
    if (bubble) {
      if (itemCount > 0) {
        bubble.classList.add('cart-link__bubble--visible');
      } else {
        bubble.classList.remove('cart-link__bubble--visible');
      }
    }
    var countEl = document.querySelector('[data-cart-count]');
    if (countEl) countEl.textContent = itemCount;
  }

  /* ══════════════════════════════════════════════════════════════
     KNAP-FEEDBACK
     ══════════════════════════════════════════════════════════════ */
  function showButtonSuccess() {
    W.atcBtn.textContent = 'Tilf\u00f8jet!';
    setTimeout(function() {
      W.atcBtn.disabled = false;
      W.atcBtn.innerHTML = W.atcBtnOriginal;
      W.atcInfo = W.picker.querySelector('[data-wccg-atc-info]');
      W.updateUI();
    }, 1500);
  }

  /* ══════════════════════════════════════════════════════════════
     AFTER CART ADD — åbn drawer eller redirect
     ══════════════════════════════════════════════════════════════ */
  /* Vent på at gave-app (AppHero) har nået at tilføje gaver, derefter hent cart */
  function fetchCartWithDelay(callback) {
    var GIFT_APP_DELAY = 1500;
    log('Waiting ' + GIFT_APP_DELAY + 'ms for gift app to process...');
    setTimeout(function() {
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(callback)
        .catch(function(err) {
          console.error('[' + W.name + ':cart] Cart fetch error:', err);
        });
    }, GIFT_APP_DELAY);
  }

  function onCartSuccess(data) {
    log('Cart add OK', data);

    var useDrawer = (MODE === 'drawer' || MODE === 'auto');

    if (useDrawer) {
      fetchCartWithDelay(function(cartData) {
        log('Cart fetched \u2014 items: ' + cartData.item_count + ', total: ' + cartData.total_price);
        updateCartBubble(cartData.item_count);
        ensureDrawer();
        renderDrawerItems(cartData);
        openDrawer();
        showButtonSuccess();
      });
      return;
    }

    if (MODE === 'checkout') {
      fetchCartWithDelay(function(cartData) {
        log('Cart fetched \u2014 items: ' + cartData.item_count + ', total: ' + cartData.total_price);
        updateCartBubble(cartData.item_count);
        log('Redirecting to /checkout');
        window.location.href = '/checkout';
      });
      return;
    }

    /* redirect mode */
    log('Redirecting to /cart');
    W.atcBtn.textContent = 'Tilf\u00f8jet!';
    window.location.href = '/cart';
  }

  /* ══════════════════════════════════════════════════════════════
     ADD TO CART
     ══════════════════════════════════════════════════════════════ */
  function addToCart() {
    var items = getCartItems();

    if (typeof W.getRelatedItems === 'function') {
      var relItems = W.getRelatedItems();
      if (relItems.length > 0) {
        log('Related items:', JSON.stringify(relItems));
        items = items.concat(relItems);
      }
    }

    if (items.length === 0) {
      log('No items to add');
      return;
    }

    log('Adding to cart:', JSON.stringify(items, null, 2));

    /* Suppress temaets drawer/alert FØR fetch — så temaet ikke kan reagere */
    if (MODE === 'drawer' || MODE === 'auto') {
      suppressThemeDrawer();
    }

    W.atcBtn.disabled = true;
    W.atcBtn.textContent = 'Tilf\u00f8jer...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function(response) {
      return response.json().then(function(data) {
        if (!response.ok) {
          log('Cart API error ' + response.status + ':', data);
          throw new Error(data.description || data.message || 'HTTP ' + response.status);
        }
        return data;
      });
    })
    .then(function(data) {
      if (data && (data.items || data.status === 200 || data.status === 'success')) {
        onCartSuccess(data);
      } else {
        throw new Error((data && data.description) || 'Uventet svar fra server');
      }
    })
    .catch(function(error) {
      console.error('[' + W.name + ':cart] Error:', error);
      restoreThemeDrawer();
      W.atcBtn.disabled = false;
      W.atcBtn.textContent = 'Fejl \u2014 pr\u00f8v igen';
      setTimeout(function() {
        W.atcBtn.innerHTML = W.atcBtnOriginal;
        W.atcInfo = W.picker.querySelector('[data-wccg-atc-info]');
        W.updateUI();
      }, 2500);
    });
  }

  /* Eksponér og bind */
  W.addToCart = addToCart;
  W.getCartItems = getCartItems;
  W.closeCartDrawer = closeDrawer;

  if (W.atcBtn) {
    W.atcBtn.addEventListener('click', addToCart);
    log('ATC button bound');
  }
})();
